import Vue from 'vue'
import Router from 'vue-router'

const TheContainer = () => import('@/containers/TheContainer')
const Dashboard = () => import('@/views/Dashboard')
const SignIn = () => import('@/views/SignIn')
const SignUp = () => import('@/views/SignUp')
const PasswordReset = () => import('@/views/PasswordReset')
const Page403 = () => import('@/views/Page403')
const Page404 = () => import('@/views/Page404')
const Repair = () => import('@/views/Repair')
const AddUser = () => import('@/views/AddUser')
const GetUsers = () => import('@/views/GetUsers')
const EditUser = () => import('@/views/EditUser')
const AddUserGroup = () => import('@/views/AddUserGroup')
const GetUserGroups = () => import('@/views/GetUserGroups')
const EditUserGroup = () => import('@/views/EditUserGroup')
const GetLogs = () => import('@/views/GetLogs')
const SendMessage = () => import('@/views/SendMessage')
const News = () => import('@/views/News')
const GetMessagesStatus = () => import('@/views/GetMessagesStatus')
const GetMessagesText = () => import('@/views/GetMessagesText')
const GetMessagesVoice = () => import('@/views/GetMessagesVoice')
// const GetMessagesArchive = () => import('@/views/GetMessagesArchive')
const GetMessagesInbox = () => import('@/views/GetMessagesInbox')
const GetBillings = () => import('@/views/GetBillings')
const AddBilling = () => import('@/views/AddBilling')
const GetMessagesStatistics = () => import('@/views/GetMessagesStatistics')
const GetMessagesStatisticsDetails = () => import('@/views/GetMessagesStatisticsDetails')
const GetMessageDetails = () => import('@/views/GetMessageDetails')
const AddFile = () => import('@/views/AddFile')
const GetFiles = () => import('@/views/GetFiles')
const AddStatusToFile = () => import('@/views/AddStatusToFile')
const GetFilesAudio = () => import('@/views/GetFilesAudio')
const PasswordChange = () => import('@/views/PasswordChange')
const GetGroupUsers = () => import('@/views/GetGroupUsers')
const AddUserToGroup = () => import('@/views/AddUserToGroup')
const GetNumbers = () => import('@/views/GetNumbers')
const GetNumberLinks = () => import('@/views/GetNumberLinks')
const AddLinkToNumber = () => import('@/views/AddLinkToNumber')
const AssignNumberToUser = () => import('@/views/AssignNumberToUser')
const AddNumber = () => import('@/views/AddNumber')
const EditNumber = () => import('@/views/EditNumber')
const GetDIDs = () => import('@/views/GetDIDs')
const AddDID = () => import('@/views/AddDID')
const GetLinks = () => import('@/views/GetLinks')
const AddLink = () => import('@/views/AddLink')
const EditLink = () => import('@/views/EditLink')
const GetTokens = () => import('@/views/GetTokens')
const AddToken = () => import('@/views/AddToken')
const EditToken = () => import('@/views/EditToken')
const GetOperators = () => import('@/views/GetOperators')
const AddOperator = () => import('@/views/AddOperator')
const EditOperator = () => import('@/views/EditOperator')
const GetFees = () => import('@/views/GetFees')
const AddFee = () => import('@/views/AddFee')
const EditFee = () => import('@/views/EditFee')
const GetFeeDetails = () => import('@/views/GetFeeDetails')
const AddFeeDetails = () => import('@/views/AddFeeDetails')
const EditFeeDetails = () => import('@/views/EditFeeDetails')
const GetGateways = () => import('@/views/GetGateways')
const GetGatewayDetails = () => import('@/views/GetGatewayDetails')
const AddGateway = () => import('@/views/AddGateway')
const EditGateway = () => import('@/views/EditGateway')
const GetBlacklist = () => import('@/views/GetBlacklist')
const AddBlacklist = () => import('@/views/AddBlacklist')
const Setting = () => import('@/views/Setting')
const Documents = () => import('@/views/Documents')
const GetSupport = () => import('@/views/GetSupport')
const AddSupport = () => import('@/views/AddSupport')
const GetSupportMessages = () => import('@/views/GetSupportMessages')
const EditSupportMessage = () => import('@/views/EditSupportMessage')
const Profile = () => import('@/views/Profile')
const GetBlacklistCustom = () => import('@/views/GetBlacklistCustom')
const AddBlacklistCustom = () => import('@/views/AddBlacklistCustom')
const EditBlacklistCustom = () => import('@/views/EditBlacklistCustom')
const Notifications = () => import('@/views/Notifications')
const GetMessagesArchiveGroups = () => import('@/views/GetMessagesArchiveGroups')
const GetMessagesStatisticsNumbers = () => import('@/views/GetMessagesStatisticsNumbers')
const GetMessagesStatisticsGateways = () => import('@/views/GetMessagesStatisticsGateways')
const GetMessagesStatisticsGatewaysOperators = () => import('@/views/GetMessagesStatisticsGatewaysOperators')
const GetMessagesStatisticsOperators = () => import('@/views/GetMessagesStatisticsOperators')
const AddGradualMessage = () => import('@/views/AddGradualMessage')
const GetGradualMessages = () => import('@/views/GetGradualMessages')
const EditGradualMessage = () => import('@/views/EditGradualMessage')
const AddReceiverToGradualMessage = () => import('@/views/AddReceiverToGradualMessage')
const GetGradualMessagesReceiver = () => import('@/views/GetGradualMessagesReceiver')
const AddSequenceToGradualMessage = () => import('@/views/AddSequenceToGradualMessage')
const GetGradualMessagesSequences = () => import('@/views/GetGradualMessagesSequences')
const EditGradualMessageSequence = () => import('@/views/EditGradualMessageSequence')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    { path: '*', component: Page404 },
    {
      path: '/',
      redirect: '/signin',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'داشبورد',
          component: Dashboard,
          meta: { requiresAuth: true },
        },
        {
          path: 'user/add',
          name: 'مدیریت کاربرها / افزودن کاربر',
          component: AddUser,
          meta: { requiresAuth: true },
        },
        {
          path: 'users',
          name: 'مدیریت کاربرها / کاربرها',
          component: GetUsers,
          meta: { requiresAuth: true },
        },
        {
          path: 'user/:id/edit',
          name: 'مدیریت کاربرها / لیست کاربرها / ویرایش کاربر',
          component: EditUser,
          meta: { requiresAuth: true },
        },
        {
          path: 'group/add',
          name: 'مدیریت کاربرها / افزودن گروه‌ کاربری',
          component: AddUserGroup,
          meta: { requiresAuth: true },
        },
        {
          path: 'groups',
          name: 'مدیریت کاربرها / گروه‌های کاربری',
          component: GetUserGroups,
          meta: { requiresAuth: true },
        },
        {
          path: 'group/:id/edit',
          name: 'مدیریت کاربرها / گروه‌های کاربری / ویرایش گروه‌ کاربری',
          component: EditUserGroup,
          meta: { requiresAuth: true },
        },
        {
          path: 'logs',
          name: 'لاگ‌ها',
          component: GetLogs,
          meta: { requiresAuth: true },
        },
        {
          path: 'message/send',
          name: 'ارسال پیام',
          component: SendMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'news',
          name: 'اطلاعیه‌ها',
          component: News,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/status',
          name: 'گزارش‌ها / تعیین وضعیت',
          component: GetMessagesStatus,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/text',
          name: 'گزارش‌ها / گزارش ارسال پیام متنی',
          component: GetMessagesText,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/voice',
          name: 'گزارش‌ها / گزارش ارسال پیام صوتی',
          component: GetMessagesVoice,
          meta: { requiresAuth: true },
        },
        // {
        //   path: 'messages/archive',
        //   name: 'گزارش‌ها / گزارش آرشیو',
        //   component: GetMessagesArchive,
        //   meta: { requiresAuth: true },
        // },
        {
          path: 'messages/archive/groups',
          name: 'گزارش‌ها / گزارش آرشیو گروه‌های پیام',
          component: GetMessagesArchiveGroups,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/inbox',
          name: 'گزارش‌ها / گزارش دریافت',
          component: GetMessagesInbox,
          meta: { requiresAuth: true },
        },
        {
          path: 'billings/:result',
          name: 'گزارش‌ها / گزارش امور مالی',
          component: GetBillings,
          meta: { requiresAuth: true },
        },
        {
          path: 'billing/add',
          name: 'شارژ آنلاین',
          component: AddBilling,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics',
          name: 'گزارش‌ها / آمار ارسال',
          component: GetMessagesStatistics,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics/:id/numbers/:type/:count_type/:user/:from/:to/:state/',
          name: 'گزارش‌ها / آمار ارسال / شماره‌ها',
          component: GetMessagesStatisticsNumbers,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics/:id/gateways/:type/:count_type/:user/:from/:to/:state/',
          name: 'گزارش‌ها / آمار ارسال / درگاه‌ها',
          component: GetMessagesStatisticsGateways,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics/:id/gateways/operators/:type/:count_type/:user/:from/:to/:state/',
          name: 'گزارش‌ها / آمار ارسال / درگاه‌ها به تفکیک اپراتور',
          component: GetMessagesStatisticsGatewaysOperators,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics/:id/operators/:type/:count_type/:user/:from/:to/:state/',
          name: 'گزارش‌ها / آمار ارسال / اپراتورها',
          component: GetMessagesStatisticsOperators,
          meta: { requiresAuth: true },
        },
        {
          path: 'messages/statistics/:id/details/:user/:from/:to/:state/',
          name: 'گزارش‌ها / جزییات آمار ارسال',
          component: GetMessagesStatisticsDetails,
          meta: { requiresAuth: true },
        },
        {
          path: 'message/:uuid/:type',
          name: 'گزارش‌ها / جزئیات پیام',
          component: GetMessageDetails,
          meta: { requiresAuth: true },
        },
        {
          path: 'file/send',
          name: 'فایل‌ها / ارسال مدارک',
          component: AddFile,
          meta: { requiresAuth: true },
        },
        {
          path: 'files',
          name: 'فایل‌ها / اسناد و مدارک',
          component: GetFiles,
          meta: { requiresAuth: true },
        },
        {
          path: 'file/:id/status',
          name: 'فایل‌ها / اسناد و مدارک / تعیین وضعیت',
          component: AddStatusToFile,
          meta: { requiresAuth: true },
        },
        {
          path: 'files/audio',
          name: 'فایل‌ها / فایل‌های صوتی',
          component: GetFilesAudio,
          meta: { requiresAuth: true },
        },
        {
          path: 'user/:id/password/reset',
          name: 'مدیریت کاربرها / لیست کاربرها / تغییر رمز عبور',
          component: PasswordChange,
          meta: { requiresAuth: true },
        },
        {
          path: 'group/:id/users',
          name: 'مدیریت کاربرها / گروه‌های کاربری / کاربرهای گروه',
          component: GetGroupUsers,
          meta: { requiresAuth: true },
        },
        {
          path: 'group/:id/user/add',
          name: 'مدیریت کاربرها / گروه‌های کاربری / افزودن کاربر',
          component: AddUserToGroup,
          meta: { requiresAuth: true },
        },
        {
          path: 'numbers',
          name: 'شماره‌ها / شماره‌ها',
          component: GetNumbers,
          meta: { requiresAuth: true },
        },
        {
          path: 'number/:id/links',
          name: 'شماره‌ها / شماره‌ها / لینک‌های شماره',
          component: GetNumberLinks,
          meta: { requiresAuth: true },
        },
        {
          path: 'number/:id/link/add',
          name: 'شماره‌ها / شماره‌ها / افزودن لینک به شماره',
          component: AddLinkToNumber,
          meta: { requiresAuth: true },
        },
        {
          path: 'number/:id/assign',
          name: 'شماره‌ها / شماره‌ها / اختصاص دادن شماره به کاربر',
          component: AssignNumberToUser,
          meta: { requiresAuth: true },
        },
        {
          path: 'number/add',
          name: 'شماره‌ها / افزودن شماره',
          component: AddNumber,
          meta: { requiresAuth: true },
        },
        {
          path: 'number/:id/edit',
          name: 'شماره‌ها / شماره‌ها / ویرایش شماره',
          component: EditNumber,
          meta: { requiresAuth: true },
        },
        {
          path: 'DIDs',
          name: 'شماره‌ها / DIDs',
          component: GetDIDs,
          meta: { requiresAuth: true },
        },
        {
          path: 'DID/add',
          name: 'شماره‌ها / افزودن DID',
          component: AddDID,
          meta: { requiresAuth: true },
        },
        {
          path: 'links',
          name: 'لینک / لینک‌ها',
          component: GetLinks,
          meta: { requiresAuth: true },
        },
        {
          path: 'link/add',
          name: 'لینک / افزودن لینک',
          component: AddLink,
          meta: { requiresAuth: true },
        },
        {
          path: 'link/:id/edit',
          name: 'لینک / لینک‌ها / ویرایش لینک',
          component: EditLink,
          meta: { requiresAuth: true },
        },
        {
          path: 'tokens',
          name: 'توکن / توکن‌ها',
          component: GetTokens,
          meta: { requiresAuth: true },
        },
        {
          path: 'token/add',
          name: 'توکن / افزودن توکن',
          component: AddToken,
          meta: { requiresAuth: true },
        },
        {
          path: 'token/:id/edit',
          name: 'توکن / توکن‌ها / ویرایش توکن',
          component: EditToken,
          meta: { requiresAuth: true },
        },
        {
          path: 'operators',
          name: 'اپراتورها / اپراتورها',
          component: GetOperators,
          meta: { requiresAuth: true },
        },
        {
          path: 'operator/add',
          name: 'اپراتورها / افزودن اپراتور',
          component: AddOperator,
          meta: { requiresAuth: true },
        },
        {
          path: 'operator/:id/edit',
          name: 'اپراتورها / اپراتورها / ویرایش اپراتور',
          component: EditOperator,
          meta: { requiresAuth: true },
        },
        {
          path: 'fees',
          name: 'تعرفه‌ها / تعرفه‌ها',
          component: GetFees,
          meta: { requiresAuth: true },
        },
        {
          path: 'fee/add',
          name: 'تعرفه‌ها / افزودن تعرفه',
          component: AddFee,
          meta: { requiresAuth: true },
        },
        {
          path: 'fee/:id/edit',
          name: 'تعرفه‌ها / تعرفه‌ها / ویرایش تعرفه',
          component: EditFee,
          meta: { requiresAuth: true },
        },
        {
          path: 'fee/:id/details',
          name: 'تعرفه‌ها / تعرفه‌ها / جزئیات تعرفه',
          component: GetFeeDetails,
          meta: { requiresAuth: true },
        },
        {
          path: 'fee/:id/details/add',
          name: 'تعرفه‌ها / تعرفه‌ها / افزودن جزئیات تعرفه',
          component: AddFeeDetails,
          meta: { requiresAuth: true },
        },
        {
          path: 'fee/details/:id/edit',
          name: 'تعرفه‌ها / تعرفه‌ها / جزئیات تعرفه / ویرایش جزئیات تعرفه',
          component: EditFeeDetails,
          meta: { requiresAuth: true },
        },

        {
          path: 'gateways',
          name: 'درگاه‌ها / درگاه‌ها',
          component: GetGateways,
          meta: { requiresAuth: true },
        },
        {
          path: 'gateway/:id/details',
          name: 'درگاه‌ها / درگاه‌ها / جزئیات درگاه',
          component: GetGatewayDetails,
          meta: { requiresAuth: true },
        },
        {
          path: 'gateway/add',
          name: 'درگاه‌ها / افزودن درگاه',
          component: AddGateway,
          meta: { requiresAuth: true },
        },
        {
          path: 'gateway/:id/edit',
          name: 'درگاه‌ها / درگاه‌ها / ویرایش درگاه',
          component: EditGateway,
          meta: { requiresAuth: true },
        },
        {
          path: 'blacklist',
          name: 'لیست سیاه',
          component: GetBlacklist,
          meta: { requiresAuth: true },
        },
        {
          path: 'blacklist/add',
          name: 'لیست سیاه / افزودن شماره',
          component: AddBlacklist,
          meta: { requiresAuth: true },
        },
        {
          path: 'setting',
          name: 'تنظیمات',
          component: Setting,
          meta: { requiresAuth: true },
        },
        {
          path: 'docs',
          name: 'مستندات',
          component: Documents,
          meta: { requiresAuth: true },
        },
        {
          path: 'support',
          name: 'پشتیبانی',
          component: GetSupport,
          meta: { requiresAuth: true },
        },
        {
          path: 'support/new',
          name: 'ایجاد مکالمه جدید',
          component: AddSupport,
          meta: { requiresAuth: true },
        },
        {
          path: 'support/:id/messages',
          name: 'پیام‌های پشتیبانی',
          component: GetSupportMessages,
          meta: { requiresAuth: true },
        },
        {
          path: 'support/:id/message/:mid',
          name: 'پیام‌های پشتیبانی / ویرایش پیام',
          component: EditSupportMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'profile/:id',
          name: 'پروفایل کاربری',
          component: Profile,
          meta: { requiresAuth: true },
        },
        {
          path: 'blacklist/custom',
          name: 'لیست سیاه اختصاصی',
          component: GetBlacklistCustom,
          meta: { requiresAuth: true },
        },
        {
          path: 'blacklist/custom/add',
          name: 'لیست سیاه اختصاصی / افزودن شماره',
          component: AddBlacklistCustom,
          meta: { requiresAuth: true },
        },
        {
          path: 'blacklist/custom/:id/edit',
          name: 'لیست سیاه اختصاصی / ویرایش شماره',
          component: EditBlacklistCustom,
          meta: { requiresAuth: true },
        },
        {
          path: 'notifications',
          name: 'نوتیفیکیشن',
          component: Notifications,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/message/add',
          name: 'افزودن پیام تدریجی',
          component: AddGradualMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/messages',
          name: 'پیام‌های تدریجی',
          component: GetGradualMessages,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/message/:id/edit',
          name: 'ویرایش پیام‌ تدریجی',
          component: EditGradualMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/message/:id/receiver/add',
          name: 'افزودن گیرنده‌ها',
          component: AddReceiverToGradualMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/messages/:id/receivers',
          name: 'گیرنده‌ها',
          component: GetGradualMessagesReceiver,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/message/:id/sequence/add',
          name: 'افزودن روند',
          component: AddSequenceToGradualMessage,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/messages/:id/sequences',
          name: 'روندها',
          component: GetGradualMessagesSequences,
          meta: { requiresAuth: true },
        },
        {
          path: 'gradual/message/sequence/:id/edit',
          name: 'ویرایش روند',
          component: EditGradualMessageSequence,
          meta: { requiresAuth: true },
        },
      ]
    },
    {
      path: '/signin',
      component: SignIn
    },
    {
      path: '/signup',
      component: SignUp
    },
    {
      path: '/password/reset',
      component: PasswordReset
    },
    {
      path: '/403',
      component: Page403,
    },
    {
      path: '/repair',
      component: Repair,
    },
  ]
}

